import DialogContent from '@mui/material/DialogContent';
import { AlertDialog } from 'components/dialog';
import { Text } from 'components/Text';
import { getTrans } from 'modules/i18n';

interface DeleteEducationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteEducationModal({
  isOpen,
  onClose,
  onConfirm
}: DeleteEducationModalProps) {
  return (
    <AlertDialog
      isOpen={isOpen}
      title={getTrans('modal.deleteEducation.title')}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmLabel={getTrans('general.delete')}
      cancelLabel={getTrans('modal.button.cancel')}
      confirmColor="error"
    >
      <DialogContent
        sx={{ color: 'text.primary', textAlign: 'center', fontSize: '13px' }}
      >
        <Text variant="body2">{getTrans('modal.deleteEducation.body')}</Text>
      </DialogContent>
    </AlertDialog>
  );
}
